import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Navigation.css';

const Navigation = () => {
  const location = useLocation();

  const navItems = [
    {
      path: '/dashboard',
      icon: '🏠',
      label: 'Home',
      activeIcon: '🏠'
    },
    {
      path: '/todos',
      icon: '📝',
      label: 'To-Do',
      activeIcon: '📝'
    },
    {
      path: '/quiz',
      icon: '🎯',
      label: 'Quiz',
      activeIcon: '🎯'
    },
    {
      path: '/notes',
      icon: '💕',
      label: 'Love Notes',
      activeIcon: '💖'
    },
    {
      path: '/profile',
      icon: '👤',
      label: 'Profile',
      activeIcon: '👤'
    }
  ];

  return (
    <nav className="bottom-navigation">
      <div className="nav-container">
        {navItems.map((item, index) => (
          <Link
            key={index}
            to={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
          >
            <div className="nav-icon">
              {location.pathname === item.path ? item.activeIcon : item.icon}
            </div>
            <span className="nav-label">{item.label}</span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;
